import mixpanel from 'mixpanel-browser';

import { getCookieIds } from '@src/shared/helpers/cookie';

let initDone = false;

function getEnvironment(): string | undefined {
    return window._env_?.ENV;
}

function getMixpanelId(): string | undefined {
    return window._env_?.MIXPANEL_ID;
}

export type DeviceType = 'mobile' | 'desktop';

export type MixpanelBaseProps = {
    application_id?: string;
    partner: string;
    device_type: DeviceType;
    event_source: string;
    url: string;
};

function getDeviceType(): DeviceType {
    if (typeof window === 'undefined') return 'desktop';
    return window.matchMedia?.('(max-width: 1023px)')?.matches
        ? 'mobile'
        : 'desktop';
}

const DEFAULT_PARTNER = 'unknown';

export function getMixpanelBaseProps(params?: {
    applicationId?: string | null;
    partner?: string | null;
}): MixpanelBaseProps {
    return {
        application_id: params?.applicationId ?? undefined,
        partner: params?.partner ?? DEFAULT_PARTNER,
        device_type: getDeviceType(),
        event_source: 'selina_web',
        url: typeof window === 'undefined' ? '' : window.location.href,
    };
}

export function initAnalytics(): void {
    if (initDone) return;
    initDone = true;

    const env = getEnvironment();
    const id = getMixpanelId();
    if (!id) return;

    mixpanel.init(id, {
        api_host: 'https://api-eu.mixpanel.com',
        debug: (env ?? '').toUpperCase() !== 'PRODUCTION',
        track_pageview: 'url-with-path',
        record_sessions_percent:
            (env ?? '').toUpperCase() === 'PRODUCTION' ? 100 : 0,
        record_mask_all_inputs: false,
        record_mask_text_selector: '',
    });
}

export function trackEvent(
    eventName: string,
    props?: Record<string, any>,
): void {
    const id = getMixpanelId();
    if (!id) return;

    try {
        const { appId, clientId } = getCookieIds();
        const baseProps = getMixpanelBaseProps({
            applicationId: appId,
            partner: clientId || undefined,
        });
        mixpanel.track(eventName, { ...baseProps, ...(props ?? {}) });
    } catch {
        // swallow analytics errors
    }
}
